import { createReducer, on } from '@ngrx/store';
import { ResetTabIndex, TabIndexChange } from '../actions/details.actions';
import { MerchantDetailsState } from '../models/merchant.model';

const initialState: MerchantDetailsState = {
  tabIndex: 0,
};

export const MerchantDetailsReducer = createReducer(
  initialState,
  on(TabIndexChange, (state) => ({
    ...state,
    tabIndex: 1,
  })),
  on(ResetTabIndex, (state) => ({
    ...state,
    tabIndex: 0,
  })),
);
